window.googletag = window.googletag || {};
googletag.cmd = googletag.cmd || [];

function initGpt() {
  googletag.pubads().addEventListener('slotRenderEnded', function(event) {
    // Remove ad label and extra padding for native ads
    const adFrame = document.querySelector(`#${event.slot.getSlotElementId()} iframe`);
    const isNativeAd =
      event.creativeTemplateId ||
      (adFrame && adFrame.contentDocument.documentElement.querySelector('#adunit'));

    if (isNativeAd) {
      const adElement = document.querySelector(`#${event.slot.getSlotElementId()}`);
      adElement.parentElement.classList.add('adunit-wrapper--native');
      adElement.classList.remove('tv2-ad__slug');
    }
  });
}

googletag.cmd.push(initGpt);
